module.exports = __webpack_public_path__ + "static/media/kangyang-3@2x.0e1dd7a5.png";